/**
 * File: authOverviewController.js
 * Project: educore
 * Created Date: 2018-12-06
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class AuthOverviewController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, menuHeaderService, AUTHDASHCONSTANT, GOOGLE_CLASSROOM_CONSTANTS, $mdDialog) {

        let authoring;

        //On init function
        // this.$onInit = () => {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            })
        } else {
            authoring = localStorageService.get("authoringData")
            if (authoring) {
                $rootScope.authMenu = true;
                $rootScope.title = authoring.class + "" + authoring.batch + "/" + authoring.curriculum + "/" + authoring.session + "/" + authoring.subject
            } else {
                $state.go("authdashboard")
            }
        }
        // }

        //On destroy function
        this.$onDestroy = () => {
            schoolId = ""
            userId = ""
            authoring = ""
            $scope.isSyllabusAvail = ""
            $scope.isThemeAvailable = ""
            $scope.isTpCreate = ""
            $scope.monthArray = ""
            $scope.themes = ""
            $scope.errorMsg = ""
        }

        // To get authoring tool side nav
        menuHeaderService.setAuthMenu()

        //String - school id
        let schoolId = localStorageService.get("school_id")

        //String - user id
        let userId = localStorageService.get("user_id")

        //Boolean - Availability of syllabus in courseware
        $scope.isSyllabusAvail = false

        //Boolean - Availability of themes in courseware
        $scope.isThemeAvailable = false

        //Boolean - privilege to create teaching plan
        $scope.isTpCreate = false

        //[String] - Array of months
        $scope.monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

        /******** For Tincan : START *********/
        // try {
        //     let tincanData = {
        //         actor: {
        //             "mbox": "mailto:" + Meteor.user().username,
        //             "account": {
        //                 "name": Meteor.user().name,
        //                 "homePage": SITE_URL
        //             },
        //             "objectType": "Agent"
        //         },
        //         verb: {
        //             id: SITE_URL + "expapi/verbs/view",
        //             display: {
        //                 "en-US": "viewed"
        //             }
        //         },
        //         object: {
        //             id: SITE_URL + "educore/authoringtool/overview/view",
        //             definition: {
        //                 type: SITE_URL + "authoring-tool",
        //                 name: {
        //                     "en-US": "overview "
        //                 },
        //                 description: {
        //                     "en-US": "To show the overview of Theme and teachingplan"
        //                 }
        //             },
        //             "objectType": "Activity"
        //         },
        //         "context": {
        //             "contextActivities": {

        //                 "Category": [{
        //                     "id": SITE_URL + "expapi/subject/" + Session.get('authoringData').subject_id,
        //                     "definition": {
        //                         "name": {
        //                             "en-US": Session.get('authoringData').subject
        //                         },
        //                         "description": {
        //                             "en-US": Session.get('authoringData').subject
        //                         }
        //                     },
        //                 }]
        //             }
        //         }
        //     }

        //     TinCanApiService.sendTincanApiRequest(tincanData)
        // } catch (ex) { }
        /******** For Tincan : END *********/

        //Service to get user privilage
        // UserPrivilages.getUserPrivilageInitialSetting(function (result) {
        //     if (result.module_privileges && result.module_privileges.length > 0) {
        //         if (result.module_privileges.findIndex(module => module.state === "authdashboard") === -1) {
        let module_privileges = localStorageService.get("module_privileges")
        if (module_privileges && module_privileges.length > 0) {
            if (module_privileges.findIndex(module => module.state === "authdashboard") === -1) {
                $state.go('dashboard')
            } else {
                // let tpUserAccess = UserPrivilages.getFeatures("teachingPlan")
                let tpUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
                    return feature.module_state == "teachingPlan"
                })
                let userAccess = {}
                _.each(tpUserAccess, function (rpObj) {
                    let user_access = {};
                    _.each(rpObj.privilege, function (privObj) {
                        user_access[privObj.name.toLowerCase()] = privObj.status
                    })
                    userAccess[rpObj.feature_id] = user_access;
                })
                if (userAccess.newTeachingPlan && userAccess.newTeachingPlan.create)
                    $scope.isTpCreate = true
                /*
                 * Function to get syllabus of the subject
                 * @authoring : Object - academic details
                 * return : [Object] - Syllabus of the subject
                 * Developer : Arul Mozhi J
                 */
                var reqObj = {
                    session_id: authoring.session_id,
                    curriculum_id: authoring.curriculum_id,
                    class_id: authoring.class_id,
                    batch_id: authoring.batch_id,
                    subject_id: authoring.subject_id,
                    school_id: schoolId,
                    academic_year: authoring.academic_year,
                    user_id: userId,
                    is_teacher: $scope.isTpCreate
                }
                authService.callAPI(AUTHDASHCONSTANT.API_AUTH_DASH_OVERVIEW_URL, 'POST', reqObj, function (resultObj) {
                    let result = resultObj.result.data;
                    if (result.success) {
                        if (result.themes && result.themes.length > 0) {
                            $scope.isThemeAvailable = true;
                            if (result.subject_description) {
                                $scope.isSyllabusAvail = true;
                                $scope.subject_description = result.subject_description;
                            }
                            $scope.themes = result.themes;
                        } else {
                            $scope.errorMsg = "No themes added for this subject."
                        }
                        _.defer(() => { $scope.$apply(); })
                    }
                })
                authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_GET_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
                    if (response.result && response.result.data && response.result.data.details) {
                        try {
                            $scope.classroomDetails = response.result.data.details
                        } catch (ex) {
                            console.log(ex);
                        }
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }
        }
        // })

        /*
         * Function to create new plan
         *  @theme_id : String - id of the themes
         *  @planName : String - Name of the plan to be created
         *  return : null
         */
        $scope.createPlan = (theme_id, theme_name, planName) => {
            localStorageService.set("plan_details", {
                theme_name: theme_name,
                plan_name: planName
            })
            $state.go("newTeachingPlan", {
                id: theme_id,
                planId: ''
            })
        }

        function showInfo(ev){
            try {
                $mdDialog.show(
                    $mdDialog.alert()
                      .parent(angular.element(document.querySelector('#popupContainer')))
                      .clickOutsideToClose(true)
                      .title('Information')
                      .htmlContent('<div style="text-align: center;">You are not added to the Classroom group required to create a course.</div><br> Please contact your administrator to ensure your account is included in the correct group.')
                      .ariaLabel('Alert Dialog Demo')
                      .ok('Cancel')
                      .targetEvent(ev)
                ).then(function() {
                    // This function will be triggered when the dialog is closed (either by clicking "Got it" or clicking outside)
                    handleDialogClose();
                });
            } catch (error) {
                console.log(error)
            }
        }
        function handleDialogClose() {
            // Your callback logic here
            location.reload();
            // You can trigger any custom logic, like logging, changing UI, etc.
        }
    
        $scope.addGoogleClassroom = function (ev) {
            console.log('ADD CLASSROOM')
            var reqObj = {
                teacher_id: userId,
                teacher_email: localStorageService.get('username'),
                session_id: authoring.session_id,
                curriculum_id: authoring.curriculum_id,
                class_id: authoring.class_id,
                batch_id: authoring.batch_id,
                subject_id: authoring.subject_id,
                school_id: schoolId,
                academic_year: authoring.academic_year,
                title: authoring.class + authoring.batch + '/' + authoring.curriculum + '/' + authoring.session + '/' + authoring.subject + ' - ' + authoring.academic_year
            }
            $scope.isLoading = true;
            authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_ADD_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
                $scope.isLoading = false;
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.classroomDetails = response.result.data.details;
                        toastr.success('Google Classroom added successfully');
                    } catch (ex) {
                        $scope.isLoading = false;
                        location.reload();
                        console.log(ex);
                    }
                } else {
                    $scope.isLoading = false;
                    // location.reload();
                    showInfo(ev)
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.viewGoogleClassroom = function () {
            pushLog();
            window.open($scope.classroomDetails.link, '_blank')
        }

        function pushLog(){ 
            let userId = localStorageService.get('user_id');
            let schoolId = localStorageService.get('school_id');
            authService.callRabbitMQAPI("/v0/rabbitmqpush/"+userId+"/"+schoolId+"/viewGoogleClassroom", "GET", {},function (response) {
            });
        } 
    }
}

export default AuthOverviewController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/controllers/authOverviewController.js